import { render, staticRenderFns } from "./PptViewer.vue?vue&type=template&id=1c14f504&"
import script from "./PptViewer.vue?vue&type=script&lang=js&"
export * from "./PptViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports